module.exports = __webpack_public_path__ + "media/bootstrap-icons/filter-circle-fill-06eb446b.svg";